import { StatusOption } from '../../utils'

export enum OrigineEnum {
  PHONE = 'PHONE',
  WEBSITE = 'WEBSITE',
  UNOSEL = 'UNOSEL'
}

export const origineEnumMapping: Record<OrigineEnum, StatusOption> = {
  [OrigineEnum.PHONE]: {
    label: 'Téléphone',
    variant: 'blue'
  },
  [OrigineEnum.WEBSITE]: {
    label: 'Site Web',
    variant: 'grey'
  },
  [OrigineEnum.UNOSEL]: {
    label: 'Unosel',
    variant: 'orange'
  }
}
